import { render, staticRenderFns } from "./ServerDanglingDbsList.vue?vue&type=template&id=ce4be6b8&scoped=true&"
import script from "./ServerDanglingDbsList.vue?vue&type=script&lang=ts&"
export * from "./ServerDanglingDbsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4be6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce4be6b8')) {
      api.createRecord('ce4be6b8', component.options)
    } else {
      api.reload('ce4be6b8', component.options)
    }
    module.hot.accept("./ServerDanglingDbsList.vue?vue&type=template&id=ce4be6b8&scoped=true&", function () {
      api.rerender('ce4be6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ServerDanglingDbsList.vue"
export default component.exports